import Procesos from './list';
import ProcesoForm from './form';

export default angular.module('spa.procesos-batch', [
  Procesos, ProcesoForm
])
  .config(config).name;


config.$inject = ['$stateProvider', '$translatePartialLoaderProvider'];

function config($stateProvider, $translatePartialLoaderProvider) {
  $stateProvider
    .state('home.procesos-batch', {
      url: 'procesos-batch',
      abstract: true,
      template: '<ui-view></ui-view>',
      ncyBreadcrumb: {
        skip: true
      }
    });
  $translatePartialLoaderProvider.addPart('procesos-batch');
}


// WEBPACK FOOTER //
// ./src/components/procesos-batch/index.js